import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { entityListExtra } from '../../../interfaces/generic-entity.interface';
import { useAppDispatch } from '../../../store/store';
import { ModalEntityListV2 } from '../../../components/lists/ModalEntityList';
import { fetchIssueList, selectIssueList } from '../store/issueListSlice';

interface ModalIssueListProps {
    open: boolean;
    handleClose: () => void;
}

const ModalIssueListDataLayer = ({ open, handleClose }: ModalIssueListProps) => {
    const dispatch = useAppDispatch();

    const entityList: entityListExtra[] | null = useSelector(selectIssueList);

    useEffect(() => {
        if (!entityList) dispatch(fetchIssueList());
    }, [dispatch, entityList]);

    return (
        <ModalEntityListV2 type="issues" list={entityList} open={open} handleClose={handleClose} />
    );
};

export default ModalIssueListDataLayer;
